import AdvantagesSection from "./AdvantagesSection"
import CardsBetaSection from "./CardsBetaSection"
import CardsDeltaSection from "./CardsDeltaSection"
import CardsGammaSection from "./CardsGammaSection"
import CardsSection from "./CardsSection"
import CareerSection from "./CareerSection"
import ColorsSection from "./ColorsSection"
import DetailsSection from "./DetailsSection"
import HeaderCompanySection from "./HeaderCompanySection"
import HeaderErrorSection from "./HeaderErrorSection"
import HeaderSection from "./HeaderSection"
import HeaderServiceSection from "./HeaderServiceSection"
import PlainSection from "./PlainSection"
import ReferencesSection from "./ReferencesSection"
import SizesSection from "./SizesSection"
import StoererSection from "./StoererSection"
import TeamSection from "./TeamSection"

const sections = {
  CardsSection,
  CardsBetaSection,
  CardsDeltaSection,
  CardsGammaSection,
  HeaderSection,
  AdvantagesSection,
  DetailsSection,
  HeaderCompanySection,
  TeamSection,
  CareerSection,
  HeaderServiceSection,
  HeaderErrorSection,
  PlainSection,
  ColorsSection,
  SizesSection,
  StoererSection,
  ReferencesSection,
}

export default sections
